import {NavLink as RouterLink} from "react-router-dom";

import {getClientUrl} from 'ultra/configs/general';
import {restorePath} from 'ultra/helpers/route'

export default function DocumentLink(props) {
    const {city, details} = props;
    return <RouterLink to={getClientUrl(city, restorePath(details._uri))}>{details.title}</RouterLink>
}
